/**
 * Which kind of failure a request met.
 *
 * Two kinds, and a form answers them differently. A refusal is the server's
 * answer about what was sent — a name already taken, a file it will not
 * take, an address that breaks the rule — and the advice is about the
 * input: try another. Weather is everything else — the network, the
 * deadline, a proxy answering mid-deploy, a server that fell over — and the
 * same request would meet it again a moment later whatever was typed.
 * "That address is taken, try another" over a connection that has gone
 * sends somebody to change the one thing that was right.
 *
 * By status. The four-hundreds are answers, except the two that are about
 * the caller rather than the input: 401, the session, and 429, the
 * throttle. No status at all — a `TypeError` from fetch, the deadline's
 * abort — is the network.
 */
export function isRefusal(error: unknown): boolean {
  const status = (error as { status?: unknown } | null)?.status;
  return (
    typeof status === "number" && status >= 400 && status < 500 && status !== 401 && status !== 429
  );
}

/**
 * The session itself is gone, not merely this one request: the token was
 * refused and the refresh said there is nothing left to refresh. The
 * caller's cue to say so instead of inviting a retry that can only ever
 * fail the same way.
 */
export function isSessionDead(error: unknown): boolean {
  return (error as { sessionDead?: unknown } | null)?.sessionDead === true;
}
